// extracted by mini-css-extract-plugin
module.exports = {"active":"TabButton_active__3mkvA","wrap":"TabButton_wrap__6pTH3"};